import React from "react";
import MaterialTable from "material-table";
import { connect } from "react-redux";
import "../../styles/Empresa.css";
import MensajeFlash from "../mensajeFlash/MensajeFlash";
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import Navbar from "../home/Navbar";
import { Link } from "react-router-dom";
import NuevoTramite from "./NuevoTramite";
import {
  Modal,
  Row,
  Col,
  Container,
  Button,
} from "react-bootstrap";
import { getTramites, eliminarTramite } from "./TramitesService";
import { codigoTramitePendiente, username } from "../../constans/constants";
import contractEdit from "../../styles/icons/contract_edit.svg";
import FirmarTramite from "./FirmarTramite";
import ExclamacionIcon from '../../styles/icons/exclamation-circle.svg';
import delete_forever from '../../styles/icons/delete.svg';


export class TramitesPendientes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mostrarMensajeFlash: false,
      mensajeFlash: "",
      severityFlash: "",
      dialogNuevoTramite: false,
      resultNuevoTramitePopUp: false,
      rowSuccess: 0,
      totalRows: 0,
      errors: [],
      dialogFirmarTramite: false,
      tramite: {
        id: '',
        nombre: '',
        estado: '',
        tipoTramite: '',
        fecha: ''
      },
      selectedTramite: {
        id: "",
        nombre: "",
        estado: "",
        tipoDocumento: "",
        fechaCarga: ""
      },
      eliminarTramite: false
    };
    localStorage.setItem("urlRaiz", window.location.href);
    this.tableRef = React.createRef();
  }

  handleCloseMensajeFlash = () => {
    this.setState({
      mostrarMensajeFlash: false,
    });
  };

  handleDialogIniciarTramite = (value, mensaje = "", severity) => {
    if (value === false) {
      this.tableRef.current.onQueryChange();  //Para actualizar la grilla
      if (mensaje != null) {
        this.setState({
          mostrarMensajeFlash: true,
          mensajeFlash: mensaje,
          severityFlash: severity
        });
      }
    }
    this.setState({
      dialogNuevoTramite: value,
    });
  };


  handleDialogIniciarFirma = (value, res) => {
    this.setState({
      resultNuevoTramitePopUp: false,
      dialogFirmarTramite: value,
    });
  };

  handleDialogEliminarTramite = (value) => {
    this.setState({
      eliminarTramite: value
    });
  }

  handleDelete = () => {
    this.setState({
      openPantallaCarga: true,
      eliminarTramite: false
    });
    eliminarTramite(this.state.selectedTramite.id).then(res => {
      this.setState({
        openPantallaCarga: false,
        open: false,
        mostrarMensajeFlash: true,
        mensajeFlash: res.mensaje,
        severityFlash: !res.error ? "success" : "danger"
      });
      this.tableRef.current.onQueryChange();
    })
  }

  render() {
    return (
      <div>
        <div className="dashboardContent">
          <div className="container-fluid">
            <PantallaCarga open={this.state.openPantallaCarga} />

            <MensajeFlash
              mensaje={this.state.mensajeFlash}
              severity={this.state.severityFlash}
              open={this.state.mostrarMensajeFlash}
              handleClose={this.handleCloseMensajeFlash}
            />

            <div className="sectionHeader">
              <h1 className="pageTitle"> Tramites Pendientes</h1>

              <div className="actions">
                <a
                  className="btn btn-primary"
                  onClick={() => this.handleDialogIniciarTramite(true, null)}
                  style={{ backgroundColor: "#00b74a" }}
                >
                  {" "}
                  Iniciar nuevo tramite{" "}
                </a>
              </div>
            </div>



            <Modal
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.dialogNuevoTramite}
              onHide={() => this.handleDialogIniciarTramite(false, null)}
              backdrop="static"
              keyboard="false"
            >
              <NuevoTramite
                handleClose={this.handleDialogIniciarTramite}
                dialogTitle="Iniciar nuevo tramite"
              />
            </Modal>
            <Modal
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.dialogFirmarTramite}
              onHide={() => this.handleDialogIniciarFirma(false, null)}
              backdrop="static"
              keyboard="false"
            >
              <FirmarTramite
                idTramite={this.state.tramite.id}
                tramite={this.state.tramite}
                urlAnterior={window.location.href}
                handleClose={this.handleDialogIniciarFirma}
                dialogTitle="Firmar Tramite"
              />
            </Modal>

            <Navbar
              menuActual={window.location.hash}
              seccionActual={"tramites"}
            />
            <div className="contentPage card" style={{ padding: "0px" }}>
              <MaterialTable
                title="Recibos"
                style={{ borderRadius: ".5rem" }}
                tableRef={this.tableRef}
                columns={[
                  { title: "Tramite", field: "nombre" },
                  { title: "Fecha de Creación", field: "fechaCarga" },
                  { title: "Estado", field: "estado" },
                ]}
                data={(query) =>
                  new Promise((resolve, reject) => {
                    this.props
                      .getTramites(query.page, query.pageSize, query.search, codigoTramitePendiente)
                      .then(() => {
                        resolve({
                          data: this.props.tramitesData.tramites,
                          page: this.props.tramitesData.page,
                          totalCount: this.props.tramitesData.totalCount,
                        });
                      });
                  })
                }
                actions={[
                  rowData => (
                    {
                      icon: () => <Link to={{ pathname: '/tramites/firma/false/' + rowData.id, state: { nombre: rowData.nombre, fechaCarga: rowData.fechaCarga } }}
                        style={{ textDecoration: 'none' }}>
                        <img src={contractEdit} />
                      </Link>,
                      tooltip: "Firmar",
                    }),
                  rowData => rowData.usernameEmisor === username() ? {
                    icon: () => <img src={delete_forever} alt="Eliminar" />,
                    tooltip: 'Eliminar',
                    onClick: (event, rowData) => {
                      this.setState({
                        selectedTramite: rowData,
                      }, () => {
                        this.handleDialogEliminarTramite(true);
                      });
                    }
                  } : null,


                ]}
                options={{
                  actionsColumnIndex: -1,
                  sorting: false,
                  paginationType: "stepped",
                  search: true,
                  showTextRowsSelected: false,
                  showTitle: false,
                  toolbar: true,
                  detailPanelColumnAlignment: "right",
                  headerStyle: {
                    background: "#edf2f9",
                    fontFamily: "Open Sans",
                    fontWeight: "bold",
                  },
                }}
                localization={{
                  body: {
                    emptyDataSourceMessage: "No hay resultados que mostrar",
                  },
                  header: {
                    actions: "Acciones",
                  },
                  pagination: {
                    labelDisplayedRows: "{from}-{to} de {count}",
                    nextTooltip: "Página Siguiente",
                    previousTooltip: "Página Anterior",
                    firstTooltip: "Primera Página",
                    lastTooltip: "Última Página",
                    labelRowsSelect: "Filas",
                  },
                  toolbar: {
                    searchPlaceholder: "Buscar",
                    searchTooltip: "Buscar",
                  },
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  getTramites: (page, size, search, estado) =>
    dispatch(getTramites(page, size, search, estado)),
});

const mapStateToProps = (state) => ({
  tramitesData: state.tramitesData,
});

export default connect(mapStateToProps, mapDispatchToProps)(TramitesPendientes);
